export const MenuData = [
  { title: "Home", icon: "/images/icons/home.svg", link: "/" },
  { title: "Documentation", icon: "/images/icons/book.svg", link: "/docs" },
  { title: "Examples", icon: "/images/icons/cube.svg", link: "/examples" },
  { title: "Themes", icon: "/images/icons/tutorials.svg", link: "/themes" },
  { title: "", icon: "/images/icons/search.svg", link: "/search" },
]

export const TooltipData = [
  { title: "", icon: "/images/icons/search.svg", link: "/search" },
]
